import React from "react"
import StandardTable from "./components/StandardTable"
import { reactWidgetWrapper } from "live/widgets/decorators/react"
import widgetService from "live/services/widgets"
import { reducer } from "./components/dataReducer"
import { type } from "./utils/constants"

const StandatdTableWidget = (
  props: LiveReactChartProps<ChartStateTable, ChartMessageTable, Configs>
): JSX.Element => {
  const value = props.state?.value
  return value && (value.id || value.values) ? (
    <StandardTable
      id={value ? (value.id !== undefined ? value.id : " ") : " "}
      values={value ? (value.values !== undefined ? value.values : " ") : " "}
      height={props.height}
    />
  ) : null
}

widgetService.register({
  get type() {
    return type
  },
  get name() {
    return "Standard Table"
  },
  get description() {
    return "A table with standard styles."
  },
  config: {},
  policies: {
    defaultReducer: "@latest",
  },
  // the wrapper is needed to enable the reducer mechanism and comply the API
  impl: reactWidgetWrapper<ChartStateTable, ChartMessageTable, Configs>(
    StandatdTableWidget,
    reducer
  ),
})
